import { render, staticRenderFns } from "./reInvestigate.vue?vue&type=template&id=50d4a0a8"
import script from "./reInvestigate.vue?vue&type=script&lang=js"
export * from "./reInvestigate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports